<template>
	<div style="height: 100%">
		<div class="buttonBox" v-if="showButton">
			<div>
				<div class="chooseButton searchButton" @click="deviceCheckItemInfoEdit('1')" v-if="MenuRoleList.indexOf('18')>=0"><i
					 class="el-icon-circle-plus-outline"></i>{{$t('btn_14')}}
				</div>
				<div class="chooseButton searchButton " @click="deviceCheckItemInfoEdit('2')" v-if="MenuRoleList.indexOf('19')>=0"><i
					 class="el-icon-edit-outline"></i>{{$t('btn_15')}}
				</div>
				<div class="chooseButton deleteButton" @click="delEquipmentTypeCheckItem" v-if="MenuRoleList.indexOf('20')>=0">
					<i class="el-icon-delete"></i>{{$t('btn_16')}}
				</div>
			</div>
		</div>
		<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableData" highlight-current-row @current-change="handleCurrentChangeTree" border
		 style="width: 100%;margin: 10px 0 10px 0px" height="87%" :header-cell-style="{'background-color': '#45494f','color': '#ffffff',}">
			<el-table-column header-align="center" align="center" :label="$t('label_369') + '.'" type="index" :index="getIndex" width="50">
			</el-table-column>
			<el-table-column prop="name" :label="$t('label_483')" align="left" width="300">
				<template slot-scope="scope">
					<span style="font-size: 16px; font-weight: 600;">
						{{scope.row.name}}
					</span>
					<br>
					<popMesBox :popMes="scope.row.content" :hoverMes="scope.row.content" :popWidth="200"></popMesBox>
				</template>
			</el-table-column>
			<el-table-column prop="planDay" :label="$t('label_494')+ '(' + $t('label_537') + ')'" align="center">
				<template slot-scope="scope">
					{{scope.row.planDay}}
				</template>
			</el-table-column>
			<el-table-column prop="cycle" :label="$t('label_499')" align="center">
				<template slot-scope="scope">
					<template v-if="scope.row.cycleType=='1'">{{scope.row.cycle=='0'?$t('label_652'):$t('label_531')+scope.row.cycle+$t('label_537')}}</template>
					<template v-if="scope.row.cycleType=='2'">
						{{scope.row.cycle==0?weekendMesOptions[6].label:weekendMesOptions[scope.row.cycle-1].label}}
					</template>
					<template v-if="scope.row.cycleType=='3'">
						{{scope.row.cycle>20?$t('label_238')+scope.row.cycle+$t('label_537'):scope.row.cycle>10?$t('label_242')+scope.row.cycle+$t('label_537'):$t('label_245')+scope.row.cycle+$t('label_537')}}
					</template>
					<template v-if="scope.row.cycleType=='4'">{{$t('label_531')+scope.row.cycle+$t('label_74')}}</template>
					<template v-if="scope.row.cycleType=='5'">
						{{$t('label_531')+scope.row.cycle.split(',')[0]+$t('label_540')+scope.row.cycle.split(',')[1]+$t('label_542')+scope.row.cycle.split(',')[2]+$t('label_537')}}
					</template>
				</template>
			</el-table-column>
			<el-table-column prop="method" :label="$t('label_340')" align="center">
				<template slot-scope="scope">
					{{positionText(scope.row.positionCode)}}
				</template>
			</el-table-column>
			<el-table-column prop="sort" v-if="needSort" :label="$t('label_501')" align="center">
				<template slot-scope="scope">
					<el-button type="text" size="small" @click="moveUp(scope.row, scope.$index)" :disabled="getIndex(scope.$index) === 1"
					 style="font-size: 20px"><i class="el-icon-arrow-up"></i>
					</el-button>
					<el-button type="text" size="small" style="font-size: 20px" @click="moveDown(scope.row, scope.$index)" :disabled="getFormLength(getIndex(scope.$index))"><i
						 class="el-icon-arrow-down"></i>
					</el-button>
				</template>
			</el-table-column>
		</el-table>

		<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
		 @parentMethod="searchPage"></Page>

		<el-dialog v-loading="saveLoading" :title="deviceParamTitle" :visible.sync="dialogDeviceSpot" append-to-body :close-on-click-modal='false'
		 width="900px" top="3%" :before-close="handleClose" custom-class="dialogBox">
			<div class="dialogBoxMes" style="padding:0 20px;">
				<div class="dialogMes">
					<p><span style="color: #ff0000">*</span>{{$t('label_483')}}</p>
					<div class="mesInput" style="width: 740px ;padding-left: 3px;">
						<el-input type="textarea" rows="1" maxlength="20" v-model="tableDataEdit.name"></el-input>
					</div>
				</div>
				<div class="dialogMes">
					<div class="dialogMes">
						<p><span style="color: #ff0000">*</span>{{$t('label_340')}}</p>
						<div class="mesInput" style="width: 740px">
							<el-select v-model="tableDataEdit.positionCode" filterable :placeholder="$t('input_65')">
								<el-option v-for="item in positionList" :key="item.code" :label="item.name" :value="item.code">
								</el-option>
							</el-select>
						</div>
					</div>
				</div>
				<div class="dialogMes">
					<p style="width: 180px;">{{$t('label_518')}}</p>
					<div class="mesInput" style="width: 740px">
						<el-checkbox-group v-model="tableDataEdit.risk">
							<el-checkbox v-for="item in riskList" :label="item" :key="item"></el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
				<div class="dialogMes">
					<p>{{$t('label_18')}}</p>
					<div class="mesInput" style="width: 740px">
						<el-radio-group v-model="tableDataEdit.maintenanceMode">
							<el-radio v-for="(item,index) in maintenanceModeList" :label="item.val" :key="item.val"></el-radio>
						</el-radio-group>
					</div>
				</div>
				<!-- <div class="dialogMes">
          <p >品质判定:</p>
          <div class="mesInput" style="width: 740px">
            本次保养是否涉及品质判定
            <el-radio v-model="tableDataEdit.attributionalJudgment" label="0">否</el-radio>
            <el-radio v-model="tableDataEdit.attributionalJudgment" label="1">是</el-radio>
          </div>
        </div> -->
				<div class="dialogMes">
					<p>{{$t('label_506')}}</p>
					<div class="mesInput" style="width: 740px">
						<el-input type="textarea" :placeholder="$t('input_49')" maxlength="500" rows="4" show-word-limit v-model="tableDataEdit.content"></el-input>
					</div>
				</div>
				<div class="dialogMes">
					<p><span style="color: #ff0000">*</span>{{$t('label_509')}}</p>
					<div class="mesInput" style="display: flex;width: 740px;justify-content: flex-start;flex-wrap: wrap">
<!--						<div class="chooseList">-->
<!--							<el-radio v-model="tableDataEdit.cycleType" label="4">-->
<!--								{{$t('label_531')}}-->
<!--								<el-input @input="$forceUpdate()" onkeyup="this.value=this.value.replace(/[^[0-9]/g,'').replace(/^0[0-9]*/g, '')"-->
<!--								 onafterpaste="this.value=this.value.replace(/[^[0-9]/g,'').replace(/^0[0-9]*/g, '')"-->
<!--								 @blur="tableDataEdit.hour = $event.target.value"  v-model="tableDataEdit.hour"-->
<!--								 style="width: 100px" :disabled="tableDataEdit.cycleType!='4'" clearable></el-input>-->
<!--								{{$t('label_534')}}-->
<!--							</el-radio>-->
<!--						</div>-->
						<div class="chooseList">
							<el-radio v-model="tableDataEdit.cycleType" label="2">
								<el-select v-model="tableDataEdit.weekend" @change="$forceUpdate()" style="width: 110px" filterable :placeholder="$t('input_65')"
								 :disabled="tableDataEdit.cycleType!='2'">
									<el-option v-for="item in weekendMesOptions" :key="item.value" :label="item.label" :value="item.value">
									</el-option>
								</el-select>
							</el-radio>
						</div>
						<div class="chooseList">
							<el-radio v-model="tableDataEdit.cycleType" label="3">
								<el-select style="width: 90px" v-model="tableDataEdit.month" filterable :placeholder="$t('input_65')" :disabled="tableDataEdit.cycleType!='3'"
								 @change="changeSelectMonth">
									<el-option v-for="(item,index) in monthOptions" :key="index" :label="item" :value="item">
									</el-option>
								</el-select>
								<el-select style="width: 90px" @change="$forceUpdate()" v-model="tableDataEdit.monthDD" :placeholder="$t('input_65')"
								 :disabled="tableDataEdit.cycleType!='3'">
									<el-option v-for="(item,index) in monthDOptions" :key="index" :label="item" :value="item" />
								</el-select>
							</el-radio>
						</div>
						<div class="chooseList">
							<el-radio v-model="tableDataEdit.cycleType" label="1">{{$t('label_531')}}
								<el-input @input="$forceUpdate()" onkeyup="this.value=this.value.replace(/[^[0-9]/g,'').replace(/^0[0-9]*/g, '')"
								 onafterpaste="this.value=this.value.replace(/[^[0-9]/g,'').replace(/^0[0-9]*/g, '')"
								   @blur="tableDataEdit.cycle = $event.target.value"
								 v-model="tableDataEdit.cycle"
								 style="width: 100px" :disabled="tableDataEdit.cycleType!='1'" clearable></el-input>
								{{$t('label_537')}}
							</el-radio>
						</div>
						<div class="chooseList">
							<el-radio v-model="tableDataEdit.cycleType" label="5">
								{{$t('label_531')}}
								<el-select style="width: 90px" @change="$forceUpdate()" v-model="tableDataEdit.year" :disabled="tableDataEdit.cycleType!='5'"
								 filterable :placeholder="$t('input_65')" clearable>
									<el-option v-for="(item,index) in 10" :key="index" :label="item" :value="item">
									</el-option>
								</el-select>
								{{$t('label_540')}}
								<el-select style="width: 90px" @change="$forceUpdate()" v-model="tableDataEdit.yearmonth" :disabled="tableDataEdit.cycleType!='5'"
								 :placeholder="$t('input_65')" clearable>
									<el-option v-for="(item,index) in 12" :key="index" :label="item" :value="item" />
								</el-select>
								{{$t('label_542')}}
								<el-select style="width: 90px" @change="$forceUpdate()" v-model="tableDataEdit.yearmonthD" :disabled="tableDataEdit.cycleType!='5'"
								 :placeholder="$t('input_65')" clearable>
									<el-option v-for="(item,index) in 31" :key="index" :label="item" :value="item" />
								</el-select>
								{{$t('label_537')}}
							</el-radio>
						</div>
					</div>
				</div>
				<div class="dialogMes">
					<div class="dialogMes">
						<p><span style="color: #ff0000">*</span>{{$t('label_494')}}</p>
						<div class="mesInput" style="width: 150px;display: flex">
							<el-input @input="$forceUpdate()" onkeyup="this.value=this.value.replace(/[^[0-9]/g,'').replace(/^0[0-9]*/g, '')"
								 onafterpaste="this.value=this.value.replace(/[^[0-9]/g,'').replace(/^0[0-9]*/g, '')"
							@blur="tableDataEdit.planDay = $event.target.value"
							 show-word-limit v-model="tableDataEdit.planDay" clearable></el-input>
							<p>{{$t('label_545')}}</p>
						</div>
					</div>
					<div class="dialogMes" style="margin-left: 25px">
						<p style="text-align: right"><span style="color: #ff0000">*</span>{{$t('label_547')}}</p>
						<div class="mesInput" style="width: 200px;display: flex">
<!--							<p style="text-align: right">{{$t('label_550')}}</p>-->
							<el-input @input="$forceUpdate()" onkeyup="this.value=this.value.replace(/[^\d]/g,'')" onafterpaste="this.value=this.value.replace(/[^\d]/g,'')"
							@blur="tableDataEdit.warningDay = $event.target.value"
							 :placeholder="$t('input_49')" show-word-limit v-model="tableDataEdit.warningDay" clearable></el-input>
							<p>{{$t('label_869')}}</p>
						</div>
					</div>
				</div>
				<div class="dialogMes">
					<p v-if="$store.getters.getVersions == 2" style="width: 100px;line-height: 25px">{{$t('label_555')}}(E-SOP)</p>
          <p v-else style="width: 100px;line-height: 25px">{{$t('label_555')}}</p>
					<div class="mesInput">
						<div class="box" style="background: #43c477;width: 50px;height: 50px;text-align:center;border-radius: 5px;margin-left: 20px;">
							<el-upload v-if="chooseFile==false" class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/"
							 :show-file-list="false" :http-request="upload">
								<i class="el-icon-upload" style="font-size: 35px;color: #ffffff;line-height: 50px;"></i>
							</el-upload>
							<div v-if="chooseFile==true" style="cursor: pointer;position:relative;">
								<i class="el-icon-success" @click="previewFile" style="font-size: 35px;color: #ffffff;line-height: 50px;"></i>
								<i class="el-icon-circle-close" @click="delFile" style="font-size: 35px;color: #000000;line-height: 50px;position:absolute;right: -45px"></i>
							</div>
							<!-- <el-tooltip class="item" effect="dark" :content="showName(tableDataEdit.fileId)" placement="bottom">
								<span class="fileName">{{showName(tableDataEdit.fileId)}}</span>
							</el-tooltip> -->
						</div>
						<span>{{showNameList}}</span>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<div class="chooseButton sendButton" @click="tableDataEditSave">{{$t('btn_13')}}</div>
			</span>
		</el-dialog>

		<el-dialog :visible="showPdf == true  || showPicture == true" :show-close="true" :width="'80%'" append-to-body class="dialog-div-pre-style"
		 :before-close="closePreviewClick" center>
			<div v-if="showPdf == true" class="dialog-body-content-base-style">
				<iframe frameborder="0" :src="$store.getters.getPostUrl+'mes/sysFile/pdf/'+pdfUrl" width='100%' height="600px">
				</iframe>
			</div>
			<div v-else-if="showPicture == true" class="dialog-body-content-base-style">
				<img style="width: 100%;height: 600px;" :src="$store.getters.getPostUrl+'mes/sysFile/download/'+pictureUrl">
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import file from "@/assets/js/file/file.js";
	import Page from "@/components/common/page";
	import utils from '@/utils/utils'
	import popMesBox from "@/components/list/popover/pop";

	export default {
		name: "maintenanceItem",
		components: {
			Page,
			popMesBox,
		},
		props: {
			showButton: {
				type: Boolean,
				default: ''
			},
			needSort: {
				type: Boolean,
				default: true
			},
		},
		data() {
			return {
        saveLoading: false,
				showNameList: '',
				pageNum: 1,
				pageSize: 50,
				MenuRoleList: [],
				tableDataEdit: {
					changeState: 0,
					content: "",
					cycle: "",
					cycleType: '4',
					equipmentTypeId: '',
					fileId: '',
					name: "",
					pid: 0,
					planDay: '',
					hour: '',
					remark: "",
					risk: [],
					sort: 0,
					warningDay: "",
					weekend: '0',
					month: this.$t('label_245'),
					monthD: '1',
					monthDD: '1',
					monthDMes: '1',
					maintenanceMode: '',
					positionCode: '0',
					// attributionalJudgment: '0',
				},
				pageCount: 0,
				deviceParamTitle: this.$t('btn_14'),
				dialogDeviceSpot: false,
				tableData: [],
				allDeviceData: [],
				weekendMesOptions: [{
					value: '1',
					label: this.$t('label_719')
				}, {
					value: '2',
					label: this.$t('label_721')
				}, {
					value: '3',
					label: this.$t('label_723')
				}, {
					value: '4',
					label: this.$t('label_725')
				}, {
					value: '5',
					label: this.$t('label_728')
				}, {
					value: '6',
					label: this.$t('label_730')
				}, {
					value: '0',
					label: this.$t('label_716')
				}, ],
				monthDOptions: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
				monthOptions: [this.$t('label_245'), this.$t('label_242'), this.$t('label_238')],
				monthOptionsObj: {
					// '每月初': ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
					// '每月中': ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
					// '每月末': ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
				},
				searchDataList: {
					deviceId: ''
				},
				tableDataTreeInfo: {},
				riskList: [],
				maintenanceModeList: [],
				chooseFile: false,
				showPdf: false,
				showPicture: false,
				positionList: [{
					"code": "0",
					"name": this.$t('label_788')
				}],
			}
		},
		methods: {
			showName(row) {
				file.selectFileName(row).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.showNameList = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
				// return this.showNameList[row]
			},
			getPositionList(equipmentTypeId) {

				file.getTypePositionList(equipmentTypeId).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.positionList = [{
							"code": "0",
							"name": this.$t('label_788')
						}];

						if (data.data.length > 0) {
							this.positionList = this.positionList.concat(data.data);
						}
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			positionText(code) {
				if (code == undefined) {
					return this.$t('label_788');
				}
				var data = this.positionList.filter(function(item) {
					return item.code == code;
				});
				if (data != '') {
					return data[0].name;
				}
			},
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			changeSelectMonth() {
				this.tableDataEdit.monthD = '';
				for (const k in this.monthOptions) {
					if (this.tableDataEdit.month === this.monthOptions[k]) {
						this.monthDOptions = this.monthOptionsObj[this.tableDataEdit.month]
					}
				}
			},
			newMes(id) {
				this.searchDataList.deviceId = id;
				this.getPositionList(id);
				this.selectRisk(id);
			},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},
			searchPage(param) {
				var dataParam = this.searchDataList;
				var newParam = Object.assign(param, dataParam);
				this.pageNum = newParam.pageNum;
				this.pageSize = newParam.pageSize;
				this.$refs['pageModel'].setCurrent(this.pageNum);
				this.getEquipmentMaintainInfo(newParam)
			},
			search() {
				let param = {
					pageNum: 1,
					pageSize: this.pageSize,
				}
				this.searchPage(param)
			},
			checkText(type) {
				var data = this.checkList.filter(function(item) {
					return item.key == type;
				});
				if (data != '') {
					return data[0].val
				}
			},
			delFile() {
				this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
					confirmButtonText: this.$t('label_100'),
					cancelButtonText: this.$t('btn_1'),
					type: 'warning'
				}).then(() => {
					this.chooseFile = false;
					this.tableDataEdit.fileId = "";
					this.showNameList='';
				}).catch(() => {

				});
			},
			getCheckList() {
        file.getByDictIdALL({dictId: 2, languageType: sessionStorage.getItem("languageType")}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.checkList = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
        // file.getCheckList().then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.checkList = data.data;
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
			},
			moveUp(item, index) {
				if (index === 0) {
					let param = {
						id: item.id,
						versionFlag: 0,
						upDown: 0
					}
					file.sortEquipmentTypeMaintainInfo2(param).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.searchPage({
								pageNum: this.pageNum,
								pageSize: this.pageSize,
							});
						}
					}).catch((response) => {
						console.log(response)
					})
				} else {
					let param = {
						id: item.id,
						sort: item.sort,
						id2: this.tableData[index - 1].id,
						sort2: this.tableData[index - 1].sort
					}
					file.sortEquipmentTypeMaintainInfo(param).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.searchPage({
								pageNum: this.pageNum,
								pageSize: this.pageSize,
							});
						}
					}).catch((response) => {
						console.log(response)
					})
				}

			},
			// 下移
			moveDown(item, index) {
				if (index === 9) {
					let param = {
						id: item.id,
						versionFlag: 0,
						upDown: 1
					}
					file.sortEquipmentTypeMaintainInfo2(param).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.searchPage({
								pageNum: this.pageNum,
								pageSize: this.pageSize,
							});
						}
					}).catch((response) => {
						console.log(response)
					})
				} else {
					let param = {
						id: item.id,
						sort: item.sort,
						id2: this.tableData[index + 1].id,
						sort2: this.tableData[index + 1].sort
					}
					file.sortEquipmentTypeMaintainInfo(param).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.searchPage({
								pageNum: this.pageNum,
								pageSize: this.pageSize,
							});
						}
					}).catch((response) => {
						console.log(response)
					})
				}

			},
			getFormLength(index) {
				if (index === this.pageCount) return true;
				else return false;
			},
			handleClose() {
				this.dialogDeviceSpot = false;
				this.tableDataEdit = {
					changeState: 0,
					content: "",
					cycle: "",
					cycleType: '4',
					equipmentTypeId: '',
					fileId: '',
					hour: '',
					name: "",
					pid: 0,
					planDay: '',
					remark: "",
					risk: [],
					sort: 0,
					warningDay: "",
					weekend: '0',
					month: this.$t('label_245'),
					monthD: '1',
					monthDD: '1',
					monthDMes: '1',
					maintenanceMode: '',
					positionCode: '0',
					// attributionalJudgment: '0',
				}
				this.tableDataEdit.maintenanceMode = this.maintenanceModeList[0].val
			},
			checkTypeText(type) {
        if (type == '1') {
          return this.$t('label_145')
        }
        if (type == '2') {
          return this.$t('label_149')
        }
        if (type == '3') {
          return this.$t('label_141')
        }
        if (type == '4') {
          return this.$t('label_138')
        }
			},
			getEquipmentMaintainInfo(param) {
				file.getEquipmentTypeMaintainInfo(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableData = data.data.records;
						this.pageSize = data.data.size;
						this.pageCount = data.data.total;
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			deviceCheckItemInfoEdit(title) {
				// if(this.riskList==null){
				// 	utils.messageAlert("请配置风险内容", this.$t('label_358'), this.$t('label_100'));
				// 	return;
				// }
				// if (this.riskList.length <= 0) {
				// 	utils.messageAlert("请配置风险内容", this.$t('label_358'), this.$t('label_100'));
				// 	return;
				// }
				this.getPositionList(this.searchDataList.deviceId);
				if (title == '2') {
					if (Object.keys(this.tableDataTreeInfo).length > 0) {
						file.getEquipmentTypeMaintainInfoMes(this.tableDataTreeInfo.id).then((response) => {
							const data = response.data;
							if (data.code == "1") {
								this.deviceParamTitle = this.$t('btn_15');
								this.tableDataEdit = data.data;
								// this.tableDataEdit.attributionalJudgment=this.tableDataEdit.attributionalJudgment.toString();
								if (this.tableDataEdit.cycleType == '1') {

								} else if (this.tableDataEdit.cycleType == '2') {
									this.tableDataEdit.weekend = this.tableDataEdit.cycle.toString();
									this.tableDataEdit.cycle = '';
								} else if (this.tableDataEdit.cycleType == '3') {
									this.tableDataEdit.monthDD = this.tableDataEdit.cycle.toString();
									let monthss = Number(this.tableDataEdit.monthDD);
									if (monthss > 20) {
										this.tableDataEdit.month = this.$t('label_238')
									} else if (monthss > 10) {
										this.tableDataEdit.month = this.$t('label_242')
									} else {
										this.tableDataEdit.month = this.$t('label_245')
									}

									this.tableDataEdit.cycle = '';
								} else if (this.tableDataEdit.cycleType == '4') {
									this.tableDataEdit.hour = this.tableDataEdit.cycle.toString();
									this.tableDataEdit.cycle = '';
								} else if (this.tableDataEdit.cycleType == '5') {
									this.tableDataEdit.year = this.tableDataEdit.cycle.split(',')[0];
									this.tableDataEdit.yearmonth = this.tableDataEdit.cycle.split(',')[1];
									this.tableDataEdit.yearmonthD = this.tableDataEdit.cycle.split(',')[2];
									this.tableDataEdit.cycle = '';
								}
								this.tableDataEdit.fileId = data.data.fileId
								if (this.tableDataEdit.fileId != "" && this.tableDataEdit.fileId != null) {
									this.chooseFile = true;
									 this.showName(this.tableDataEdit.fileId)
								} else {
									this.chooseFile = false;
									this.showNameList='';
								}
								this.tableDataEdit.cycleType = this.tableDataEdit.cycleType.toString();
								this.tableDataEdit.risk = JSON.parse(this.tableDataEdit.risk)
								this.dialogDeviceSpot = true;
							} else {
								utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
							}
						}).catch((response) => {
							console.log(response)
						})
					} else {
						utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
					}
				} else {
					this.dialogDeviceSpot = true;
					this.deviceParamTitle = this.$t('btn_14');
					this.chooseFile = false;
					this.showNameList='';
				}
			},
			upload(file1) {
				var formData = new FormData();
				formData.append('file', file1.file);
				file.upload(formData).then((response) => {
					const data = response.data;
					if (data.code == 1) {
						this.tableDataEdit.fileId = data.data
						this.showName(data.data)
						this.$message({
							message: this.$t('msg_15'),
							type: 'success'
						});
						this.chooseFile = true;
					} else {
            utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
					}
				}).catch((response) => {
					console.log(response)
					this.$message({
						message: this.$t('label_404'),
						type: 'error'
					});
				})
			},
			previewFile() {
				file.selectFileType(this.tableDataEdit.fileId).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						let type = data.data;
						if (type.indexOf(".pdf") != -1) {
							this.pdfUrl = this.tableDataEdit.fileId;
							this.showPdf = true
						} else if (type.indexOf(".jpg") != -1 || type.indexOf(".png") != -1 || type.indexOf(".jpeg") != -1) {
							this.pictureUrl = this.tableDataEdit.fileId;
							this.showPicture = true
						} else {
							this.$message(this.$t('msg_9'))
						}
					} else {
						this.$message(this.$t('msg_10'))
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			closePreviewClick() {
				if (this.showPdf == true) {
					this.showPdf = false
				} else if (this.showPicture == true) {
					this.showPicture = false
				}
			},
			tableDataEditSave() {
				// console.log(this.tableDataEdit.hour);
				// console.log(this.tableDataEdit.cycleType);
				// return;
        this.saveLoading = true;
				if (this.tableDataEdit.cycleType == '1') {

				} else if (this.tableDataEdit.cycleType == '2') {
					this.tableDataEdit.cycle = this.tableDataEdit.weekend
				} else if (this.tableDataEdit.cycleType == '3') {
					this.tableDataEdit.cycle = this.tableDataEdit.monthDD
				} else if (this.tableDataEdit.cycleType == '4') {
					this.tableDataEdit.cycle = this.tableDataEdit.hour;
				} else if (this.tableDataEdit.cycleType == '5') {
					this.tableDataEdit.cycle = this.tableDataEdit.year + ',' + this.tableDataEdit.yearmonth + ',' + this.tableDataEdit
						.yearmonthD;
				}
				if (this.tableDataEdit.name == null || this.tableDataEdit.name == '') {
					utils.messageAlert(this.$t('msg_125'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
					return;
				}
				// if (RegExp("((?=[\x21-\x7e]+)[^A-Za-z0-9])").test(this.tableDataEdit.name)) {
				// 	utils.messageAlert("保养项目不能包含特殊符号", this.$t('label_358'), this.$t('label_100'));
				// 	return;
				// }
				this.tableDataEdit.equipmentTypeId = this.searchDataList.deviceId;
				// if (this.tableDataEdit.risk == null || this.tableDataEdit.risk == '') {
				// 	utils.messageAlert("请选择作业风险", this.$t('label_358'), this.$t('label_100'));
				// 	return;
				// }
				if (this.tableDataEdit.cycle == null || this.tableDataEdit.cycle == '') {
					utils.messageAlert(this.$t('msg_126'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
					return;
				}
				if (this.tableDataEdit.cycleType == "4") {
					if (isNaN(parseInt(this.tableDataEdit.hour))) {
						utils.messageAlert(this.$t('msg_127'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
						return;
					}
				}
				if (this.tableDataEdit.cycleType == "1") {
					if (isNaN(parseInt(this.tableDataEdit.cycle))) {
						utils.messageAlert(this.$t('msg_127'), this.$t('label_358'), this.$t('label_100'));
            this.saveLoading = false;
						return;
					}
				}
				if (this.tableDataEdit.planDay == null || this.tableDataEdit.planDay == '') {
					utils.messageAlert(this.$t('msg_110'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
					return;
				}
				if (isNaN(parseInt(this.tableDataEdit.planDay))) {
					utils.messageAlert(this.$t('msg_128'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
					return;
				}
				if (this.tableDataEdit.warningDay === null || this.tableDataEdit.warningDay === '') {
					utils.messageAlert(this.$t('msg_121'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
					return;
				}
				if (isNaN(parseInt(this.tableDataEdit.warningDay))) {
					utils.messageAlert(this.$t('msg_122'), this.$t('label_358'), this.$t('label_100'));
          this.saveLoading = false;
					return;
				}
				this.tableDataEdit.risk = JSON.stringify(this.tableDataEdit.risk)
				if (this.deviceParamTitle == this.$t('btn_14')) {
					this.tableDataEdit.sort = this.pageCount + 1;
					file.saveEquipmentTypeMaintainInfo(this.tableDataEdit).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.dialogDeviceSpot = false;
							this.tableDataEdit = {
								changeState: 0,
								content: "",
								cycle: "",
								cycleType: '4',
								equipmentTypeId: '',
								fileId: '',
								name: "",
								pid: 0,
								planDay: '',
								remark: "",
								risk: [],
								sort: 0,
								hour: '',
								warningDay: "",
								weekend: '0',
								month: this.$t('label_245'),
								monthD: '1',
								monthDD: '1',
								monthDMes: '1',
								maintenanceMode: '',
								// attributionalJudgment: '0',
							}
							this.tableDataEdit.maintenanceMode = this.maintenanceModeList[0].val
							this.search();
						} else {
							utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
							this.tableDataEdit.risk = JSON.parse(this.tableDataEdit.risk)
						}
            this.saveLoading = false;
					}).catch((response) => {
						console.log(response)
						this.tableDataEdit.risk = JSON.parse(this.tableDataEdit.risk)
            this.saveLoading = false;
					})
				} else {
					file.saveEquipmentTypeMaintainInfoEdit(this.tableDataEdit).then((response) => {
						const data = response.data;
						if (data.code == "1") {
							this.dialogDeviceSpot = false;
							this.tableDataEdit = {
								changeState: 0,
								content: "",
								cycle: "",
								cycleType: '4',
								equipmentTypeId: '',
								fileId: '',
								name: "",
								pid: 0,
								planDay: '',
								remark: "",
								risk: [],
								sort: 0,
								warningDay: "",
								weekend: '0',
								hour: '',
								month: this.$t('label_245'),
								monthD: '1',
								monthDD: '1',
								monthDMes: '1',
								maintenanceMode: '',
								// attributionalJudgment: '0',
							}
							this.tableDataEdit.maintenanceMode = this.maintenanceModeList[0].val
							this.search();
						} else {
							utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
							this.tableDataEdit.risk = JSON.parse(this.tableDataEdit.risk)
						}
            this.saveLoading = false;
					}).catch((response) => {
						console.log(response)
						this.tableDataEdit.risk = JSON.parse(this.tableDataEdit.risk)
            this.saveLoading = false;
					})
				}
			},
			delEquipmentTypeCheckItem() {
				let param = this.tableDataTreeInfo.id;
				if (Object.keys(this.tableDataTreeInfo).length > 0) {
					this.$confirm(this.$t('msg_66') + '?', this.$t('label_358'), {
						confirmButtonText: this.$t('label_100'),
						cancelButtonText: this.$t('btn_1'),
						type: 'warning'
					}).then(() => {
						file.delEquipmentTypeMaintainInfo(param).then((response) => {
							const data = response.data;
							if (data.code == "1") {
								this.search();
							} else {
								utils.messageAlert(data.message, this.$t('label_358'), this.$t('label_100'));
							}
						}).catch((response) => {
							console.log(response)
						})
					}).catch(() => {

					});
				} else {
					utils.messageAlert(this.$t('input_38'), this.$t('label_358'), this.$t('label_100'));
				}
			},
			selectRisk(id) {
				let param = {
					id: id,
					type: 0
				};
				file.selectRisk(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.riskList = data.data
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			selectMaintenanceModeList() {
        file.getByDictIdALL({dictId: 24, languageType: sessionStorage.getItem("languageType")}).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.maintenanceModeList = data.data
						this.tableDataEdit.maintenanceMode = data.data[0].val
					}
				}).catch((response) => {
					console.log(response)
				})
        // file.getDictList(24).then((response) => {
        //   const data = response.data;
        //   if (data.code == "1") {
        //     this.maintenanceModeList = data.data
        //     this.tableDataEdit.maintenanceMode = data.data[0].val
        //   }
        // }).catch((response) => {
        //   console.log(response)
        // })
			},

		},
		created() {
			this.getCheckList();
			this.selectMaintenanceModeList();
			this.MenuRoleList = this.$store.getters.getMenu;
      this.$set(this.monthOptionsObj, this.$t('label_245'), ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']);
      this.$set(this.monthOptionsObj, this.$t('label_242'), ['11', '12', '13', '14', '15', '16', '17', '18', '19', '20']);
      this.$set(this.monthOptionsObj, this.$t('label_238'), ['21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31']);
		}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/list/displayPage/maintenanceItem.vue